import { render, staticRenderFns } from "./FormularioEquipeComponent.vue?vue&type=template&id=913fc706"
import script from "./FormularioEquipeComponent.vue?vue&type=script&lang=js"
export * from "./FormularioEquipeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports